export function Logo() {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        style={{ filter: "drop-shadow(0 0 8px rgba(78,225,240,0.5))" }}
      >
        <path d="M12 2 L22 7 L22 17 L12 22 L2 17 L2 7 Z" fill="none" stroke="var(--cyan)" strokeWidth="1.5" />
        <path d="M12 2 L12 22 M2 7 L22 17 M22 7 L2 17" stroke="var(--cyan)" strokeWidth="0.6" opacity="0.5" />
        <circle cx="12" cy="12" r="2" fill="var(--cyan)" />
      </svg>
      <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
        <div style={{ fontSize: 13, fontWeight: 600, letterSpacing: "0.06em" }}>
          VERA RUBIN <span style={{ color: "var(--cyan)" }}>HPC</span>
        </div>
        <div
          style={{
            fontSize: 9,
            color: "var(--fg-3)",
            fontFamily: "var(--mono)",
            letterSpacing: "0.1em",
            marginTop: 2,
          }}
        >
          MONITORING · v0.1.0
        </div>
      </div>

      {/* Author badge — intentionally prominent. Click → Nemo portfolio (bottom of page) */}
      <a
        href="https://nemo-ai-portfolio.pages.dev/#bottom"
        target="_blank"
        rel="noreferrer noopener"
        onClick={(e) => {
          // Same-tab-preferred nav: let browser open in a new tab on modifier,
          // otherwise navigate current tab so Chrome's fragment scroll works.
          if (!e.metaKey && !e.ctrlKey && !e.shiftKey) {
            e.preventDefault();
            window.open("https://nemo-ai-portfolio.pages.dev/#bottom", "_blank", "noopener,noreferrer");
          }
        }}
        style={{
          marginLeft: 6,
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "5px 10px 5px 8px",
          borderRadius: 999,
          border: "1px solid rgba(78,225,240,0.35)",
          background:
            "linear-gradient(90deg, rgba(78,225,240,0.14), rgba(157,123,255,0.10))",
          boxShadow: "0 0 14px rgba(78,225,240,0.18)",
          textDecoration: "none",
          color: "inherit",
          cursor: "pointer",
          transition: "filter 160ms, transform 160ms",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.filter = "brightness(1.12)";
          e.currentTarget.style.transform = "translateY(-1px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.filter = "";
          e.currentTarget.style.transform = "";
        }}
        title="Open Nadav Chen's portfolio (nemo-ai-portfolio.pages.dev)"
      >
        <div
          style={{
            width: 22,
            height: 22,
            borderRadius: "50%",
            background: "linear-gradient(135deg, var(--cyan), var(--violet))",
            color: "#0a0f17",
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: "0.02em",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 0 8px rgba(78,225,240,0.55)",
          }}
        >
          NC
        </div>
        <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
          <div
            style={{
              fontSize: 9,
              letterSpacing: "0.16em",
              color: "var(--fg-3)",
              fontFamily: "var(--mono)",
              textTransform: "uppercase",
              marginBottom: 2,
            }}
          >
            Created by
          </div>
          <div
            style={{
              fontSize: 13,
              fontWeight: 700,
              color: "var(--fg-0)",
              letterSpacing: "0.02em",
            }}
          >
            Nadav <span style={{ color: "var(--cyan)" }}>Chen</span>
            <span style={{ marginLeft: 6, color: "var(--fg-3)", fontSize: 10, fontWeight: 500 }}>↗</span>
          </div>
        </div>
      </a>
    </div>
  );
}
